export const MODIFY_DATE_UPGRADED = 'MODIFY_DATE_UPGRADED';

export function modifyDateUpgraded(dateUpgraded){
    return{
        type: MODIFY_DATE_UPGRADED,
        mainState: {
            dateUpgraded: dateUpgraded
        }
    }
}